<div class="bottom-action-bar" [style.background-color]="backgroundColor()">
  <button class="bottom-action-bar-button" (click)="actionClick.emit()">
    <span>
      <strong>{{ title() }}</strong>
      @if (subtitle()) {
        | {{ subtitle() }}
      }
    </span>
    <umss-icon [name]="iconName()" />
  </button>
</div>
